// Pagination configuration for different page types
export const PAGINATION_DEFAULTS = {
  applications: {
    small: 3, // Small screens (mobile)
    medium: 5, // Medium screens (tablet)
    large: 10, // Large screens (desktop)
  },
  users: {
    small: 5,
    medium: 10,
    large: 20,
  },
  vendors: {
    small: 5,
    medium: 10,
    large: 20,
  },
  orders: {
    small: 5,
    medium: 10,
    large: 15,
  },
  transactions: {
    small: 5,
    medium: 15,
    large: 25,
  },
  catalogue: {
    small: 4, // For cards/grid layouts
    medium: 8,
    large: 12,
  },
  categories: {
    small: 3,
    medium: 6,
    large: 10,
  },
  experiences: {
    small: 5,
    medium: 10,
    large: 20,
  },
  promoCodes: {
    small: 5,
    medium: 10,
    large: 15,
  },
} as const;

// Screen size breakpoints (matching your existing MUI breakpoints)
export const SCREEN_BREAKPOINTS = {
  small: 600, // xs-sm
  medium: 960, // sm-md
  large: 1280, // md+
} as const;

// Helper function to get appropriate page size based on screen dimensions
export const getSmartPageSize = (
  pageType: keyof typeof PAGINATION_DEFAULTS
): number => {
  const screenHeight = window.innerHeight;
  const screenWidth = window.innerWidth;

  // Use the smaller dimension to determine the appropriate size
  const effectiveSize = Math.min(screenHeight, screenWidth);

  const config = PAGINATION_DEFAULTS[pageType];

  if (effectiveSize < SCREEN_BREAKPOINTS.small) {
    return config.small;
  } else if (effectiveSize < SCREEN_BREAKPOINTS.medium) {
    return config.medium;
  } else {
    return config.large;
  }
};

// Hook to get responsive page size that updates on window resize
export const useSmartPageSize = (
  pageType: keyof typeof PAGINATION_DEFAULTS
): number => {
  const getPageSize = () => getSmartPageSize(pageType);

  // You can add a useState and useEffect here if you want it to be reactive to window resize
  // For now, we'll just calculate it once
  return getPageSize();
};
